import Phaser from "phaser";
import dbManager from "./dbManager";

export const textureToMapConfig = (textures, id) => {
  const texture = textures.get(id);
  const image = texture.getSourceImage();
  const levelConfig = Array(image.height)
    .fill("000000")
    .map(() => Array(image.width).fill("000000"));
  for (let j = 0; j < image.width; j++) {
    for (let i = 0; i < image.height; i++) {
      const pixColor = textures.getPixel(j, i, id);
      const key = `${Phaser.Display.Color.ComponentToHex(
        pixColor.r
      )}${Phaser.Display.Color.ComponentToHex(
        pixColor.g
      )}${Phaser.Display.Color.ComponentToHex(pixColor.b)}`;
      levelConfig[i][j] = key;
    }
  }
  return levelConfig;
};

const _ = (n) =>
  n.toLocaleString("en-US", {
    minimumIntegerDigits: 2,
  });

export const formatScore = (value, total) =>
  typeof total == 'number' ? `${_(value)}/${_(total)}` : "__/__";

export const formatComp = (value) => {
  const perc = (value * 100).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return value
    ? ` ${perc <= 9 ? "  " : perc <= 99 ? " " : ""}${perc}%`
    : "   -";
};

export const drawGemsScore = (lKey) => {
  const levelData = dbManager.get(lKey);
  return formatScore(levelData?.collectedDiamonds, levelData?.countDiamonds);
};
export const drawThreatsScore = (lKey) => {
  const levelData = dbManager.get(lKey);
  return formatScore(levelData?.killedEnemies, levelData?.countEnemies);
};
export const drawShroomsScore = (lKey) => {
  const levelData = dbManager.get(lKey);
  return formatScore(levelData?.collectedShrooms, levelData?.countShrooms);
};
export const drawCompScore = (lKey) => {
  const levelData = dbManager.get(lKey);
  return formatComp(levelData?.comp);
};
